import {
  createContext, useContext, useEffect, ReactNode, useState,
} from 'react';
import { Role } from 'lib/types';
import { useApi, useCurrentUser } from 'lib/contexts/ApplicationState';

type ProviderProps = { roles?: Role[]; children: ReactNode };
const RolesContext = createContext<Role[] | undefined>(undefined);

function useRoles() {
  return useContext(RolesContext);
}

function RolesProvider({ roles, children }: ProviderProps) {
  const API = useApi();
  const [localRoles, setRoles] = useState<Role[] | undefined>(roles);
  const currentUser = useCurrentUser();

  useEffect(() => {
    const getRoles = async () => {
      try {
        const rolesData = await API.listAllRoles();
        setRoles(rolesData);
      } catch (error) {
        console.error('Error fetching roles', error);
      }
    };
    if (!localRoles) getRoles();
  }, [localRoles, currentUser]);

  return (
    <RolesContext.Provider value={localRoles}>
      {children}
    </RolesContext.Provider>
  );
}

export { RolesProvider, useRoles };
